import { Icon } from '@/components/ui/Icon';
import { ICONS } from '@/constants/icons';

interface SectionTitleProps {
  title: string;
  className?: string;
}

export const SectionTitle = ({ title, className = '' }: SectionTitleProps) => {
  return (
    <h3
      className={`inline-flex items-center gap-2 border-l-2 border-primary-500 pl-3 text-lg font-bold uppercase tracking-[0.08em] text-gray-900 cursor-grab active:cursor-grabbing ${className}`}
    >
      <span>{title}</span>
      <span
        aria-hidden="true"
        className="inline-flex h-[18px] w-[18px] shrink-0 items-center justify-center text-gray-400 opacity-0 transition-opacity group-hover/dashboard-row:opacity-100 group-focus-within/dashboard-row:opacity-100"
      >
        <Icon name={ICONS.HAND} size="sm" ariaHidden />
      </span>
    </h3>
  );
};
